import React, { memo } from 'react';
import { timelineMagic, timelineAcqua } from '../mock';

const Item = ({ year, text, side }) => (
  <div className={`relative flex items-start gap-6 ${side === 'right' ? 'md:flex-row-reverse md:text-right' : ''}`}>
    <div className="hidden md:flex w-1/2 justify-end items-center pr-8">
      {side === 'left' && (
        <div className="bg-white rounded-lg shadow-md p-5 border-l-4 border-brand-red max-w-md">
          <p className="text-gray-700 leading-relaxed">{text}</p>
        </div>
      )}
    </div>
    <div className="shrink-0 z-10">
      <div className="w-16 h-16 rounded-full bg-brand-red text-white font-display font-bold text-lg flex items-center justify-center shadow-lg border-4 border-white">{year}</div>
    </div>
    <div className="flex-1 md:w-1/2 md:pl-8">
      {(side === 'right' || true) && (
        <div className={`bg-white rounded-lg shadow-md p-5 border-l-4 border-brand-red max-w-md ${side === 'left' ? 'md:hidden' : ''}`}>
          <p className="text-gray-700 leading-relaxed">{text}</p>
        </div>
      )}
    </div>
  </div>
);

const Storia = () => {
  return (
    <section id="azienda" className="py-20 md:py-28 bg-gray-50 relative">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-display text-3xl md:text-5xl font-bold text-center text-brand-navy uppercase title-underline">La Nostra Storia</h2>

        <div className="mt-16">
          <h3 className="font-display text-xl md:text-2xl font-bold text-center text-brand-red uppercase tracking-wide mb-10">Magic Deumidificazioni Sagl</h3>
          <div className="relative">
            <div className="hidden md:block timeline-line" />
            <div className="space-y-10">
              {timelineMagic.map((e, i) => (
                <Item key={i} year={e.year} text={e.text} side={i % 2 === 0 ? 'left' : 'right'} />
              ))}
            </div>
          </div>
        </div>

        <div className="mt-24">
          <h3 className="font-display text-xl md:text-2xl font-bold text-center text-brand-red uppercase tracking-wide mb-10">Acqua Project (ora brand di Magic)</h3>
          <div className="relative">
            <div className="hidden md:block timeline-line" />
            <div className="space-y-10">
              {timelineAcqua.map((e, i) => (
                <Item key={i} year={e.year} text={e.text} side={i % 2 === 0 ? 'left' : 'right'} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(Storia);
